import { createAction } from "redux-actions";

export const SET_CURRENT_STATE = "metabase/qb/SET_CURRENT_STATE";
export const setCurrentState = createAction(SET_CURRENT_STATE);
